import { useCallback, useEffect, useState } from "react";
import { PageHero, Section } from "../components/PageKit";
import { usePageMeta } from "../lib/seo";
import { empApi, getEmpToken, getEmpKind, clearEmpSession } from "../lib/employment";
import PortalAuth from "../components/employment/PortalAuth";
import PartnerRegisterForm from "../components/employment/PartnerRegisterForm";
import SeekerRegisterForm from "../components/employment/SeekerRegisterForm";
import PartnerDashboard from "../components/employment/PartnerDashboard";
import SeekerDashboard from "../components/employment/SeekerDashboard";

const COPY = {
  partner: { kicker: "Employment Bridge", title: "Job Partner Portal", text: "Offer genuine jobs to verified, currently unemployed Dutsen Kauna Foundation volunteers. Every offer is reviewed by our staff, who select the most suitable candidates for you. Approved partners become official Employment Partners of the Foundation.", auth: "Job Partner sign-in", meta: "Job Partner Portal | Employment Bridge | Dutsen Kauna Foundation" },
  seeker: { kicker: "Employment Bridge", title: "Job Seeker Portal", text: "For Foundation volunteers who are currently unemployed. Create your profile once; our staff verify your volunteer status and match you to opportunities from approved Job Partners. You never apply directly — and it is always free.", auth: "Job Seeker sign-in", meta: "Job Seeker Portal | Employment Bridge | Dutsen Kauna Foundation" },
};

// Shared page for /employment/partner and /employment/jobseeker: auth → register → dashboard.
export default function EmploymentPortal({ kind }) {
  const c = COPY[kind];
  usePageMeta(c.meta, c.text);
  const [me, setMe] = useState(null);
  const [mode, setMode] = useState("auth");
  const [prefill, setPrefill] = useState("");
  const load = useCallback(() => empApi.get("/me").then((r) => { if (r.data.kind !== kind) throw new Error("kind"); setMe(r.data); }).catch(() => { setMe(null); }), [kind]);
  useEffect(() => { if (getEmpToken() && getEmpKind() === kind) load(); }, [load, kind]);
  const signOut = () => { clearEmpSession(); setMe(null); setMode("auth"); };

  if (me) return kind === "partner" ? <PartnerDashboard me={me} reload={load} signOut={signOut} /> : <SeekerDashboard me={me} reload={load} signOut={signOut} />;
  return (
    <div data-testid={`employment-${kind}-page`}>
      <PageHero kicker={c.kicker} title={c.title} text={c.text} />
      <Section>
        {mode === "auth" && <PortalAuth kind={kind} title={c.auth} prefillEmail={prefill} onSignedIn={load} onRegister={() => setMode("register")} />}
        {mode === "register" && kind === "partner" && <PartnerRegisterForm onRegistered={(email) => { setPrefill(email); setMode("auth"); }} onCancel={() => setMode("auth")} />}
        {mode === "register" && kind === "seeker" && <SeekerRegisterForm onRegistered={(email) => { setPrefill(email); setMode("auth"); }} onCancel={() => setMode("auth")} />}
      </Section>
    </div>
  );
}
